import React from "react";
import ListPageLayout from "@layouts/ListPageLayout";
import { withRouter } from "react-router";

import TurnToChargeFilterFrom from './TurnToChargeFilterFrom';
import TurnToChargeListTable from './TurnToChargeListTable';
import turn_store,{filter_store} from "@store/Statistic/TurnToCharge/TurnToChargeStore";
import breadcrumb_store from '@src/Store/Common/MyBreadcrumb';

@withRouter
class TurnToChargeList extends React.PureComponent
{
    constructor(props) {
        super();
        let id          = props.location.id;
        let state       = props.location.state;
        let username    = props.location.username;
        this.updateDatas(state,id,username);
    }

    componentWillReceiveProps(props, nextContext) {
        let state = props.location.state;
        this.updateDatas(state);
    }
    updateDatas(state){
        breadcrumb_store.resetByName('转充列表','转充列表')
        if (state===undefined){
            filter_store.resetAttr()
        }else {
            filter_store.setAttr(state)
        }
        turn_store.state = state;
    }

    render(){
        return (
            <ListPageLayout
                isCustomHeader
                header={<TurnToChargeFilterFrom />}
                list={<TurnToChargeListTable />}
            />
        );
    }
}
export default TurnToChargeList;


// WEBPACK FOOTER //
// ./src/ViewsDashboard/Statistic/TurnToCharge/TurnToChargeList.jsx